import axios from 'axios';
import { LoginFormValuesProps } from 'containers/login-form/helpers';
import { useMutation } from 'react-query';

const login = async (
  email: string,
  password: string,
  recaptchaV3Token?: string,
  recaptchaV3Action?: string,
  recaptchaV2Token?: string
) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/oauth/token`,
    { email, password, recaptchaV3Token, recaptchaV3Action, recaptchaV2Token }
  );
  return data;
};

const useLogin = (props = {}) =>
  useMutation(
    ({
      email,
      password,
      recaptchaV3Token,
      recaptchaV3Action,
      recaptchaV2Token
    }: LoginFormValuesProps) =>
      login(
        email,
        password,
        recaptchaV3Token,
        recaptchaV3Action,
        recaptchaV2Token
      ),
    props
  );

export default useLogin;
